import type { PropsWithChildren } from 'react';

import { Stack } from '@/lib/shadcn/components/ui/stack/stack';
import { cn } from '@/lib/shadcn/lib/utils';

type Props = {
  className?: string;
};

export function BasePageLayout({ className, children }: PropsWithChildren<Props>) {
  return <Stack className={cn('h-dvh', className)}>{children}</Stack>;
}
